// extracted by mini-css-extract-plugin
export default {"textUnderline":"d9f0e9f0bf9b"};